import { UrlParamKeyValuePair } from '@gn-audio/jss-core';

// used in customizer only, to display a discount for joined discount (product + accessory)
export const customizerAccessoryPromoQuery: UrlParamKeyValuePair[] = [
  {
    key: 'tempCode',
    value: 'accessory',
  },
];
